import React from 'react'
import * as S from './styles'
import { UseFormRegisterReturn } from 'react-hook-form'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  id: string
  isChecked: boolean
  register: UseFormRegisterReturn
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  id,
  isChecked,
  register,
  ...rest
}) => {
  const inputId = `${id}-checkbox`

  return (
    <S.CheckboxContainer>
      <input
        type="checkbox"
        id={inputId}
        checked={isChecked}
        {...rest}
        {...register}
      />
      <label htmlFor={inputId}>{label}</label>
    </S.CheckboxContainer>
  )
}

export default Checkbox
